'use strict';

var React = require('react'),
    AboutSocialProofSection = require('../organisms/AboutSocialProofSection'),
    AboutCoverSection = require('../organisms/AboutCoverSection'),
    AboutFeedSection = require('../organisms/AboutFeedSection'),
    AboutStampsSection = require('../organisms/AboutStampsSection'),
    AboutZinesSection = require('../organisms/AboutZinesSection'),
    AboutSectionTypes = require('../constants/AboutSectionTypes'),
    NavigationContextTypes = require('../constants/NavigationContextTypes'),
    OverlayStore = require('../stores/OverlayStore'),
    Page = require('../organisms/Page'),
    Dots = require('../molecules/Dots'),
    Icon = require('../atoms/Icon'),
    Scrolljack = require('../organisms/Scrolljack'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    ScreenSizeMixin = require('../mixins/ScreenSizeMixin'),
    Easings = require('../constants/Easings'),
    KeyCodes = require('../constants/KeyCodes'),
    getSupportedTransformProperty = require('../utils/getSupportedTransformProperty'),
    AppContext = require('../AppContext'),
    { isMobile } = require('../utils/Browser');

const aboutSections = [
  AboutSectionTypes.COVER,
  AboutSectionTypes.STAMPS,
  AboutSectionTypes.ZINES,
  AboutSectionTypes.FEED,
  AboutSectionTypes.SOCIAL_PROOF
];

const transitionDuration = 1000;
// const transformProperty = getSupportedTransformProperty();

const styles = {
  dots: {
    position: 'absolute',
    right: 0,
    top: 0,
    bottom: 0,
    margin: 'auto',
  },

  learnMore: {
    normal: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      padding: '.75rem',
      fontWeight: 'bold',
      cursor: 'pointer',
      backgroundColor: AboutStampsSection.backgroundColor,
      // [transformProperty.js]: `translate3d(0, 200%, 0)`,
      // transition: `${transformProperty.css} ${transitionDuration}ms ${Easings.BEZIER}`,
    },

    active: {
      // [transformProperty.js]: `translate3d(0, 0, 0)`,
      transitionDelay: '1s'
    }
  }
};

var AboutPage = React.createClass({
  mixins: [PureRenderMixin, ScreenSizeMixin],

  getInitialState() {
    return {
      showVideo: false,
      activeSectionIndex: 0
    };
  },

  getNavigationContext() {
    const { activeSectionIndex, showVideo } = this.state;
    const isAboutCover = activeSectionIndex === 0;

    return [NavigationContextTypes.ABOUT, {
      isAboutCover,
      isAboutCoverVideo: isAboutCover && showVideo
    }];
  },

  getAppContext() {
    const [navigationContextType, navigationContextOptions] = this.getNavigationContext();
    return {
      navigationContextType,
      navigationContextOptions
    };
  },

  canScrolljack() {
    return this.state.isDesktop && !isMobile();
  },

  componentDidMount() {
    window.scrollTo(0, 0);
    window.addEventListener('keydown', this.handleWindowKeyDown);
  },

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleWindowKeyDown);
  },

  render() {
    const { activeSectionIndex, showVideo } = this.state;

    let navigation = null;
    if (!showVideo) {
      navigation = (
        <Dots activeIndex={activeSectionIndex}
              requestActiveIndexChange={this.handleRequestActiveSectionIndexChange}
              count={aboutSections.length}
              style={styles.dots} />
      );
    }

    return (
      <AppContext {...this.getAppContext()}>
        <Page>
          <Scrolljack disabled={!this.canScrolljack()}
                      activeIndex={activeSectionIndex}
                      requestActiveIndexChange={this.handleRequestActiveSectionIndexChange}
                      transitionDuration={transitionDuration}
                      extraDisableScrollDuration={250}
                      navigation={navigation}>
            {aboutSections.map(this.renderAboutSection)}
          </Scrolljack>
        </Page>
      </AppContext>
    );
  },

  renderAboutSection(type, index) {
    const { activeSectionIndex, showVideo } = this.state;

    let Section;
    let props = {
      key: type,
      layout: 'section',
      active: index === activeSectionIndex || !this.canScrolljack()
    };

    switch (type) {
    case AboutSectionTypes.COVER:
      Section = AboutCoverSection;
      Object.assign(props, {
        showVideo: showVideo,
        showLogo: true,
        layout: (showVideo ? 'full' : 'section'),
        footer: this.renderLearnMore(),
        onRequestShowVideoChange: this.handleRequestShowVideoChange
      });
      break;

    case AboutSectionTypes.STAMPS:
      Section = AboutStampsSection;
      break;

    case AboutSectionTypes.ZINES:
      Section = AboutZinesSection;
      break;

    case AboutSectionTypes.FEED:
      Section = AboutFeedSection;
      break;

    case AboutSectionTypes.SOCIAL_PROOF:
      Section = AboutSocialProofSection;
      break;
    }

    return (
      <Section {...props} />
    );
  },

  renderLearnMore() {
    const { activeSectionIndex } = this.state;
    const isActive = activeSectionIndex === 0;

    if (this.canScrolljack()) {
      return (
        <div onClick={this.handleLearnMoreClick}
             style={Object.assign({},
               styles.learnMore.normal,
               isActive && styles.learnMore.active
             )}>
          Learn More
          {'   '}
          <Icon context='AboutPage'
                name='arrowDown'
                mode='stroke'
                size='xsmall' />
        </div>
      );
    }
  },

  handleRequestShowVideoChange(showVideo) {
    this.setState({ showVideo });
  },

  handleRequestActiveSectionIndexChange(index) {
    if (this.state.showVideo) {
      return;
    }

    this.setActiveSection(index);
  },

  handleLearnMoreClick() {
    this.setActiveSection(1);
  },

  handleWindowKeyDown(e) {
    if (!this.canScrolljack() || OverlayStore.hasAny() || this.state.showVideo) {
      return;
    }

    const { activeSectionIndex } = this.state;

    switch (e.keyCode) {
    case KeyCodes.HOME:
      this.setActiveSection(0);
      break;
    case KeyCodes.END:
      this.setActiveSection(Infinity);
      break;
    case KeyCodes.UP:
    case KeyCodes.PAGE_UP:
      this.setActiveSection(e.metaKey ? 0 : activeSectionIndex - 1);
      break;
    case KeyCodes.DOWN:
    case KeyCodes.PAGE_DOWN:
      this.setActiveSection(e.metaKey ? Infinity : activeSectionIndex + 1);
      break;
    case KeyCodes.SPACE:
      this.setActiveSection(activeSectionIndex + (e.shiftKey ? -1 : 1));
      break;
    }
  },

  setActiveSection(index) {
    index = Math.max(0, index);
    index = Math.min(index, aboutSections.length - 1);

    this.setState({
      activeSectionIndex: index
    });
  }
});

module.exports = AboutPage;



/** WEBPACK FOOTER **
 ** ./pages/AboutPage.jsx
 **/